import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function AnnouncementBar() {
  const {
    t
  } = useLanguage();
  return <div className="bg-navy text-white" data-id="element-37" data-mp="olbvhsiz52cu">
      <p className="mx-auto max-w-7xl px-4 py-2 text-center text-xs font-medium tracking-wide sm:text-sm" data-id="element-38" data-mp="ju3iynmcl0vg">
        {t.announcement}
      </p>
    </div>;
}